export default __webpack_public_path__ + "static/media/040-circular-arrows.a760184e.png";